<template>
  <div>
    <el-card class="box-card" style="cursor: pointer;margin-top:10px;">
      <el-row>
        <el-col :span="6">
          <img alt="美钥二维码" :src="qr.qrfile" style="width:80px;height:80px;">
        </el-col>
        <el-col :span="18">
          <div style="line-height:25px;">
            <div>名称:{{name}}</div>
            <div> 类型:{{qr.qrtype.qrtypedesc}}</div>
            <div>内容:{{qr.qrdest}}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script type="text/css" scoped>
export default {
  props: ['qr'],
  computed: {
    name () {
      if (this.qr.qrname !== '') {
        return this.qr.qrname
      }
      return '未命名'
    }
  }
}
</script>
